import { AddressSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as z from "zod";
import { ItemSchema } from "./common/item-schema";

export const completeExchangeConversion = {
  name: "completeExchangeConversion" as const,
  method: "unary" as const,
  input: z.object({
    returnId: z.string(),
    newItems: z.array(ItemSchema),
    newOrderAddress: AddressSchema.optional(),
  }),
  output: z.object({
    success: z.boolean(),
    returnId: z.string(),
    message: z.string().optional(),
  }),
};
